import Vue from "vue";
import App from "./App.vue";
import AOS from "aos";
import "aos/dist/aos.css";
import Chakra, { CThemeProvider, CReset } from "@chakra-ui/vue";
import VueRouter from "vue-router";

Vue.use(Chakra);
Vue.use(VueRouter);

const routes = [
  { path: "/", component: require("../src/components/Container.vue").default },
  {
    path: "/projects",
    component: require("../src/components/Projects.vue").default,
  },
  {
    path: "/contact",
    component: require("../src/components/Contact.vue").default,
  },
];

const router = new VueRouter({
  routes,
});

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(CThemeProvider, [h(CReset), h(App)]),
  mounted() {
    AOS.init();
  },
}).$mount("#app");
